import { Module, MutationTree, ActionTree, GetterTree } from 'vuex'
import { IWidgetState } from '.'
import { IShowAllConfig } from '../models/config-interface'

interface IShowAllState {
    config: IShowAllConfig
}

class ShowAllState implements IShowAllState {
    config: IShowAllConfig = {
        labels: {}
    }
}

const mutations: MutationTree<IShowAllState> = {
    setConfig(state, config: IShowAllConfig) {
        state.config = config
    },
}

const actions: ActionTree<IShowAllState, IWidgetState> = {
}

const getters: GetterTree<IShowAllState, IWidgetState> = {
    labels(state): {} {
        return state.config.labels
    }
}

export const showAll: Module<IShowAllState, any> = {
    namespaced: true,
    state: new ShowAllState,
    mutations,
    actions,
    getters,
}